var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.terkunci)?_c('div',{staticClass:"caption warning--text text--darken-2 mt-1"},[_c('v-icon',{staticClass:"mr-1",attrs:{"x-small":"","color":"warning darken-2"}},[_vm._v("mdi-lock")]),_vm._v(" "+_vm._s(_vm.pesan)+" ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }